const destinations = [
  { name: "Cancun", country: "Mexico", flag: "🇲🇽", desc: "Most popular spring break and family destination from Little Rock. Direct flights available via Dallas." },
  { name: "London", country: "UK", flag: "🇬🇧", desc: "Business and leisure travel hub. Popular with UALR study abroad students." },
  { name: "Barcelona", country: "Spain", flag: "🇪🇸", desc: "Top European destination for Arkansas travelers. Rich culture and Mediterranean beaches." },
  { name: "Tokyo", country: "Japan", flag: "🇯🇵", desc: "Growing business destination for Little Rock corporate travelers." },
  { name: "Cruise Ports", country: "Various", flag: "🚢", desc: "New Orleans and Galveston cruise departures — most popular for Little Rock families." },
  { name: "Sydney", country: "Australia", flag: "🇦🇺", desc: "Adventure and educational travel destination for long-term trips." },
];

export default function LittleRockDestinationsSection() {
  return (
    <section id="destinations" className="py-16 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Popular Destinations</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">Where Little Rock Travelers Go</h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {destinations.map((d, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6 hover:border-[#F6C344] transition-all">
              <div className="flex items-center gap-3 mb-3">
                <span className="text-2xl">{d.flag}</span>
                <div>
                  <h3 className="font-bold text-[#1A365D] text-lg">{d.name}</h3>
                  <p className="text-gray-400 text-xs">{d.country}</p>
                </div>
              </div>
              <p className="text-gray-500 text-sm leading-relaxed">{d.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}